import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Descriptions, Flex } from 'antd';
import RegLibProductStringDisplay from './regLibProductStringDisplay';
import { Typography } from 'antd';
const { Text } = Typography;
const horizontalItems = (props) => {
    var _a, _b;
    const id = props.data.strRegLibId;
    const country = (_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.objLuCountry) === null || _b === void 0 ? void 0 : _b.strLongDesc;
    const product = props.data.lstMapProductType;
    const service = props.data.strServiceTypes;
    const dataArr = [
        _jsx(Descriptions.Item, { label: "Country", span: 3, children: country }, `${id}_rl_dash_table_1`),
        _jsx(Descriptions.Item, { label: "Service", span: 3, children: service }, `${id}_rl_dash_table_2`)
    ];
    if (!product || !(product === null || product === void 0 ? void 0 : product.length)) {
        dataArr.push(_jsx(Descriptions.Item, { label: "Product Category", children: _jsx(Text, { children: "ALL" }, `${id}_rl_dash_table_all`) }, `${id}_rl_dash_table_3_all`));
    }
    return dataArr;
};
const verticalItems = (props) => {
    const id = props.data.strRegLibId;
    const product = props.data.lstMapProductType;
    const dataArr = [];
    if (product && (product === null || product === void 0 ? void 0 : product.length)) {
        dataArr.push(_jsx(Descriptions.Item, { label: "Product Category", children: _jsx(RegLibProductStringDisplay, { data: product, additionalProp: id }) }, `${id}_rl_dash_table_3`));
    }
    return dataArr;
};
const RegulationsDetailTable = ({ data }) => (_jsxs(Flex, { vertical: true, gap: 0, children: [_jsx(Descriptions, { size: "small", layout: "horizontal", children: horizontalItems({ data }) }, `${data.strRegLibId}_rl_dash_table_horizontal`), _jsx(Descriptions, { size: "small", layout: "vertical", children: verticalItems({ data }) }, `${data.strRegLibId}_rl_dash_table_vertical`)] }));
export default RegulationsDetailTable;
